import React, { useEffect, useContext, useState } from 'react';

//styles
import styles from './EditeLanding.module.scss';
import copyOfInstallLanding from '../installLandings/InstallLanding.module.scss';
import copyOFNewUserModal from '../../../shared/NewUserModal.module.scss';

//components
import Loading from '../../../shared/Loading';

//dependencys
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useStateWithCallbackLazy } from 'use-state-with-callback';
import { HexColorPicker } from 'react-colorful';
import axios from 'axios';

//contexts
import { myUserDataContext } from '../../../App';

//functions
import { responseHandler } from '../../../functions/responseHandler';
import { changeFaToEn } from '../../../functions/changeFaToEn';
import { notify } from '../../../functions/toasts';
import { debounce } from 'lodash';
import CustomSelect from 'react-select';

//shared
import ModalYesorNo from '../../../shared/ModalYesorNo';
import { Select } from 'antd';

const EditeLanding = () => {
  const navigate = useNavigate();
  const params = useParams();

  const data = useContext(myUserDataContext);
  const { userData, isLogin, mainUrl } = data;
  const { token, user } = userData;

  console.log(user?.roles?.[0]?.permissions);

  const isAccess =
    user?.roles?.[0]?.permissions?.includes('show-landing-details') ??
    false;

  const [copyOfData, setCopyOfData] = useState({});

  const [dataOfTemplate, setDataOfTemplate] = useState([]);

  const [selectOptions, setSelectOptions] = useState({
    subject: [],
    label: [],
    type: [],
  });

  const [checkBtnEdite, setCheckBtnEdite] = useState(false);
  const [editeLanding, setEditeLanding] = useStateWithCallbackLazy(
    {}
  );
  const [isLoad, setIsLoad] = useState(true);
  const [loadingType, setLoadingType] = useState();
  const [keyupdateLanding, setKeyupdateLanding] = useState(false);

  const [allLandings, setAllLandings] = useState([]);
  const [deleteVar, setDelete] = useState([]);

  const [mainPara, setMainPara] = useState({});
  const [mainLand, setMainLand] = useState({});
  const [unEditableLand, setUnEditableLand] = useState({});
  const [unEditableParameter, setUnEditableParameter] = useState({});
  const [templateCopies, setTemplateCopies] = useState([]);
  const [groups, setGroups] = useState([]);
  const [templateCopiesUnEditable, setTemplateCopiesUnEditable] =
    useState([]);
  const [paramIndex, setParamIndex] = useState(0);
  const [othersParameters, setOthersParameters] = useState({
    variants: [],
  });
  const [landings, setLandings] = useState({
    CTR_target: '',
    change_type: '',
    landing_group_id: '',
    landings: [],
  });

  const [othersParametersEditable, setOthersParametersEditable] =
    useState({
      variants: [],
    });

  const [landingsEditable, setLandingsEditable] = useState({
    landings: [],
  });

  const [paraPriority, setParaPriority] = useState(1);
  const [landPriority, setLandPriority] = useState(1);
  const [advance, setAdvance] = useState(false);

  const fetchLandings = async (title = '') => {
    try {
      const url = title
        ? `/landing/search-landing?title=${encodeURIComponent(title)}`
        : `/landing/search-landing`;

      const res = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (res.data.status) {
        const options = res.data.data.map((item) => ({
          label: item.title,
          value: item.id,
        }));
        setAllLandings(options);
      }
    } catch (err) {
      responseHandler(err, 'error');
    }
  };

  useEffect(() => {
    fetchLandings();
  }, []);

  const debouncedFetch = debounce((value) => {
    if (value.length >= 2) {
      fetchLandings(value);
    }
  }, 500);

  const handleInputChange = (value) => {
    debouncedFetch(value);
  };

  // const getSelectOptions = () => {
  //   setIsLoad(true);
  //   axios
  //     .get('/landing/get-landing-subjects', {
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //       },
  //     })
  //     .then((res) => {
  //       if (res.data.status) {
  //         setSelectOptions((prev) => ({
  //           ...prev,
  //           subject: res.data.subjects,
  //           label: res.data.labels,
  //         }));
  //         setIsLoad(false);
  //       } else {
  //         responseHandler(res, 'error');
  //       }
  //     })
  //     .catch((error) => {
  //       responseHandler(error, 'error');
  //     });
  // };

  const getTypeOptions = (first) => {
    setLoadingType(true);
    axios
      .get(`/landing/get-landing-types?token=${first}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        if (res.data.status) {
          setSelectOptions((prev) => ({
            ...prev,
            type: res.data?.data?.types,
          }));

          setLoadingType(false);
        } else {
          //  responseHandler(res, "error");
        }
      })
      .catch((error) => {
        //  responseHandler(error, "error");
      });
  };

  useEffect(() => {
    axios
      .get(
        `/landing/show/${params.id}?relations[]=groups&relations[]=parameterGroup.variants`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then(async (res) => {
        responseHandler(res, 'succ', false);
        if (res.data.status) {
          const {
            title,
            slug,
            access_group_id,

            parameters,
            is_child,
            landing_group,
            parameter_group,
          } = res.data.data;

          setEditeLanding({
            title: title,
            slug: slug,
            access_group_id: access_group_id,
            parameters: JSON.parse(parameters),
            is_child,
            landing_group,
            parameter_group,

            landing_group,
          });
          getTypeOptions(JSON.parse(parameters).token);
          setCopyOfData({
            title: title,
            slug: slug,
            access_group_id: access_group_id,
            parameters: JSON.parse(parameters),
          });

          await axios
            .get(`/template/show/${res.data.data.template_id}`, {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            })
            .then((res2) => {
              if (res2.data.status) {
                setDataOfTemplate([
                  ...JSON.parse(res2.data.data.parameters),
                ]);
                setIsLoad(false);
              }
            })
            .catch((error2) => {
              responseHandler(error2, 'error');
            });

          // getSelectOptions();
        }
      })
      .catch((error) => {
        responseHandler(error, 'error');
        if (error.response?.status === 404)
          navigate('/notfound', { replace: true });
      });
  }, [keyupdateLanding]);

  useEffect(() => {
    if (editeLanding?.parameter_group?.variants) {
      const max = Math.max(
        ...editeLanding?.parameter_group?.variants.map(
          (item) => item.priority
        )
      );

      setParaPriority(max);
    }
  }, [editeLanding?.parameter_group?.variants]);

  useEffect(() => {
    if (editeLanding?.landing_group?.[0]?.groups) {
      const max = Math.max(
        ...editeLanding?.landing_group?.[0]?.groups.map(
          (item) => item?.pivot?.priority
        )
      );

      setLandPriority(max);
    }
  }, [editeLanding?.landing_group?.[0]?.groups]);

  const inputHandler = (e) => {
    if (e.target.name === 'title') {
      const firstTitle = changeFaToEn(e.target.value);
      setEditeLanding({
        ...editeLanding,
        title: firstTitle,
        parameters: {
          ...editeLanding.parameters,
          baseAndMainTitle: firstTitle,
        },
      });
      return;
    }

    const first = changeFaToEn(e.target.value);
    setEditeLanding({ ...editeLanding, [e.target.name]: first });
  };

  const colorHandler = (e, name, type) => {
    if (type === 'input') {
      setEditeLanding({
        ...editeLanding,
        parameters: {
          ...editeLanding.parameters,
          [name]: e.target.value,
        },
      });
    } else if ('picker') {
      setEditeLanding({
        ...editeLanding,
        parameters: { ...editeLanding.parameters, [name]: e },
      });
    }
  };

  const inputParaHandler = (e) => {
    let first = changeFaToEn(e.target.value);
    const name = e.target.name;

    setEditeLanding({
      ...editeLanding,
      parameters: {
        ...editeLanding.parameters,
        [name === 'typeSelect' ? 'type' : name]: first,
      },
    });
  };
  const inputParaHandler2 = (e) => {
    const first = changeFaToEn(e.target.value);
    console.log(first, 'copy');
    getTypeOptions(first);
    setEditeLanding({
      ...editeLanding,
      parameters: {
        ...editeLanding.parameters,
        [e.target.name]: first,
      },
    });
    setOthersParametersEditable((prev) => ({
      ...prev,
      variants: prev.variants.map((variant) => ({
        ...variant,
        parameters: {
          ...variant.parameters,
          [e.target.name]: first,
        },
      })),
    }));
  };

  const inputParaHandler3 = (e) => {
    const first = changeFaToEn(e.target.value);
    console.log(first, 'copy');
    getTypeOptions(first);
    setEditeLanding({
      ...editeLanding,
      parameters: {
        ...editeLanding.parameters,
        [e.target.name]: first,
      },
    });
    setOthersParametersEditable((prev) => ({
      ...prev,
      variants: prev.variants.map((variant) => ({
        ...variant,
        parameters: {
          ...variant.parameters,
          [e.target.name]: first,
        },
      })),
    }));
  };

  const ColorPickerShowHandler = (e, type) => {
    if (type === 'enter') {
      e.target.previousElementSibling.style.display = 'initial';
    } else if (type === 'leave') {
      let currentElement = e.target;

      while (currentElement.parentElement) {
        currentElement = currentElement.parentElement;

        if (currentElement.id === 'test') {
          currentElement.style.display = 'none';
          break;
        }
      }
    }
  };

  const compareObjects = (a, b) => {
    return JSON.stringify(a) === JSON.stringify(b);
  };

  const editeLandingHandler = () => {
    setCheckBtnEdite(true);

    let bodySend = {};

    for (let item in copyOfData) {
      if (item === 'parameters') {
        if (
          compareObjects(copyOfData[item], editeLanding[item]) ===
          false
        )
          bodySend[item] = editeLanding[item];
      } else {
        if (copyOfData[item] !== editeLanding[item])
          bodySend[item] = editeLanding[item];
      }
    }

    if (bodySend.title === '') {
      notify('عنوان لندینگ نمی‌تواند خالی باشد', 'error');
      setCheckBtnEdite(false);
      return;
    }

    if (bodySend.slug === '') {
      notify('آدرس لندینگ نمی‌تواند خالی باشد', 'error');
      setCheckBtnEdite(false);
      return;
    }

    if (bodySend.access_group_id === '') {
      notify('گروه لندینگ نمی‌تواند خالی باشد', 'error');
      setCheckBtnEdite(false);
      return;
    }

    // if (
    //   editeLanding.parameters.labelSelect !== undefined &&
    //   editeLanding.parameters.subjectSelect !== undefined
    // ) {
    //   if (
    //     editeLanding.parameters.labelSelect !== '' &&
    //     editeLanding.parameters.subjectSelect === ''
    //   ) {
    //     notify(
    //       'در صورت انتخاب برچسب باید موضوع را هم انتخاب کرده باشید',
    //       'error',
    //       2000,
    //     );
    //     setCheckBtnEdite(false);
    //     return;
    //   }

    //   const totalHamkadehOrNot =
    //     editeLanding.parameters.hamkadehOrNot !== undefined
    //       ? editeLanding.parameters.hamkadehOrNot
    //       : editeLanding.parameters.HamkadehOrNot;

    //   if (
    //     totalHamkadehOrNot === '' &&
    //     editeLanding.parameters.labelSelect === ''
    //   ) {
    //     notify(
    //       'در صورتی که لندینگ برای همکده است باید برچسب و تمامی موارد در بخش ملزومات لندینگ را وارد کنید',
    //       'error',
    //       4500,
    //     );
    //     setCheckBtnEdite(false);
    //     return;
    //   }
    // }

    // if (editeLanding.parameters.subjectSelect !== undefined) {
    //   if (
    //     editeLanding.parameters.subjectSelect !== '' &&
    //     editeLanding.parameters.type === ''
    //   ) {
    //     notify(
    //       'اگر موضوع انتخاب کرده باشید باید تایپ هم داشته باشید',
    //       'error',
    //       2000,
    //     );
    //     setCheckBtnEdite(false);
    //     return;
    //   }

    //   if (
    //     editeLanding.parameters.subjectSelect !== '' &&
    //     editeLanding.parameters.token === ''
    //   ) {
    //     notify(
    //       'اگر موضوع انتخاب کرده باشید باید توکن هم داشته باشید',
    //       'error',
    //       2000,
    //     );
    //     setCheckBtnEdite(false);
    //     return;
    //   }
    // }

    const _method = 'put';
    const formData = new FormData();

    const filteredvariants = othersParametersEditable?.variants || [];

    const filteredLandings = landingsEditable.landings || [];

    const parameterIndex = editeLanding?.parameter_group?.variants
      ? editeLanding?.parameter_group?.variants.length
      : 0;

    const landIndex = editeLanding?.landing_group?.[0]?.variants
      ? editeLanding?.landing_group?.[0]?.variants.length
      : 0;

    for (let item in bodySend) {
      if (item === 'parameters')
        formData.append(
          `${item}`,
          JSON.stringify({ ...bodySend[item] })
        );
      else formData.append(`${item}`, bodySend[item]);
    }

    formData.append('_method', _method);

    if (mainLand?.[0] && landingsEditable.landings.length > 0) {
      formData.append(
        'landing_group[landing_group_id]',
        String(parseInt(mainLand[0].landing_group_id))
      );
    }

    if (
      mainPara?.[0] &&
      othersParametersEditable?.variants.length > 0
    )
      formData.append(
        'parameter_group[parameter_group_id]',
        mainPara?.[0]?.parameter_group_id
      );
    if (deleteVar.length > 0) {
      console.log(deleteVar, 'deleteVar in edite landing');
      formData.append(
        'parameter_group[parameter_group_id]',
        mainPara?.[0]?.parameter_group_id
      );
    }

    if (filteredLandings.length > 0 && editeLanding?.is_child != 1) {
      if (!mainLand?.[0])
        formData.append(
          'landing_group[CTR_target]',
          landings.CTR_target
        );

      if (!mainLand?.[0])
        formData.append(
          'landing_group[change_type]',
          landings.change_type !== ''
            ? landings.change_type
            : 'view_change'
        );

      filteredLandings.forEach((landing, index) => {
        if (landing.id)
          formData.append(
            `landing_group[landings][${index + landIndex + 1}][id]`,
            landing.id
          );
        if (landing.priority)
          formData.append(
            `landing_group[landings][${
              index + landIndex + 1
            }][priority]`,
            landing.priority
          );
        if (landing.time_change)
          formData.append(
            `landing_group[landings][${
              index + landIndex + 1
            }][time_change]`,
            landing.time_change
          );
        if (landing.view_change)
          formData.append(
            `landing_group[landings][${
              index + landIndex + 1
            }][view_change]`,
            landing.view_change
          );
      });
    }

    if (deleteVar?.length > 0) {
      deleteVar.forEach((id) => {
        formData.append('parameter_group[delete_variants][]', id);
      });
    }

    if (filteredvariants?.length > 0 && !mainPara?.[0]) {
      formData.append(
        'parameter_group[CTR_target]',
        editeLanding.parameter_group.CTR_target
      );
    }

    if (editeLanding?.parameter_group && !mainPara?.[0])
      formData.append(
        'parameter_group[change_type]',
        editeLanding.parameter_group.change_type ?? 'view_change'
      );

    if (filteredvariants?.length > 0) {
      filteredvariants?.forEach((item, index) => {
        formData.append(
          `parameter_group[variants][${
            index + parameterIndex + 1
          }][parameters]`,
          JSON.stringify(item.parameters)
        );

        if (item.priority)
          formData.append(
            `parameter_group[variants][${
              index + parameterIndex + 1
            }][priority]`,
            item.priority
          );
        if (item.time_change)
          formData.append(
            `parameter_group[variants][${
              index + parameterIndex + 1
            }][time_change]`,
            item.time_change
          );
        if (item.view_change)
          formData.append(
            `parameter_group[variants][${
              index + parameterIndex + 1
            }][view_change]`,
            item.view_change
          );
      });
    }

    formData.append('is_child', editeLanding.is_child);

    if (editeLanding.time_change) {
      formData.append('time_change', editeLanding.time_change);
    } else if (mainLand?.[0]?.time_change) {
      formData.append(
        'time_change',
        mainLand?.[0]?.pivot?.time_change
      );
    }

    if (editeLanding.parameter_change && !mainPara?.[0]) {
      formData.append(
        'parameter_change',
        editeLanding.parameter_change
      );
    } else if (mainPara?.[0]?.view_change) {
      formData.append('parameter_change', mainPara?.[0]?.view_change);
    } else if (mainPara?.[0]?.time_change) {
      formData.append('parameter_change', mainPara?.[0]?.time_change);
    }
    if (editeLanding.view_change) {
      formData.append('view_change', editeLanding.view_change);
    } else if (mainLand?.[0]?.view_change) {
      formData.append(
        'view_change',
        mainLand?.[0]?.pivot?.view_change
      );
    }

    // if (
    //   editeLanding.parameters.subjectSelect !== '' &&
    //   editeLanding.parameters.subjectSelect !== undefined
    // ) {
    //   const bodyPanel = {
    //     landing_token: editeLanding.parameters.token,
    //     location:
    //       editeLanding.parameters.HamkadehOrNot === ''
    //         ? 'hamkadeh'
    //         : editeLanding.parameters.HamkadehOrNot === '1'
    //           ? 'old_5040'
    //           : '5040',
    //     type: editeLanding.parameters.type,
    //     subject: editeLanding.parameters.subjectSelect,
    //     ...(editeLanding.parameters.labelSelect !== '' && {
    //       label: editeLanding.parameters.labelSelect,
    //     }),
    //   };

    //   axios
    //     .post(`/landing/send-landing-subjects`, bodyPanel, {
    //       headers: {
    //         Authorization: `Bearer ${token}`,
    //       },
    //     })
    //     .then((res) => {
    //       if (res.data.status) {
    //         axios
    //           .post(`/landing/update/${params.id}`, formData, {
    //             headers: {
    //               Authorization: `Bearer ${token}`,
    //             },
    //           })
    //           .then((res) => {
    //             responseHandler(res, 'succ');
    //             if (res.data.status) {
    //               setIsLoad(true);
    //               setKeyupdateLanding(!keyupdateLanding);
    //             }
    //             setCheckBtnEdite(false);
    //           })
    //           .catch((error) => {
    //             responseHandler(error, 'error');
    //             setCheckBtnEdite(false);
    //           });
    //       } else {
    //         notify('توکن وب سرویس وارد شده اشتباه است', 'error');
    //         setCheckBtnEdite(false);
    //       }
    //     })
    //     .catch((error) => {
    //       responseHandler(error, 'error');
    //       setCheckBtnEdite(false);
    //     });
    // } else {
    axios
      .post(`/landing/update/${params.id}`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        responseHandler(res, 'succ');
        if (res.data.status) {
          setIsLoad(true);
          setKeyupdateLanding(!keyupdateLanding);
        }
        setCheckBtnEdite(false);
      })
      .catch((error) => {
        responseHandler(error, 'error');
        setCheckBtnEdite(false);
      });
    // }
  };

  const fetchGroups = async (title = '') => {
    try {
      const url = `/access-group/get-user-list?name=${encodeURIComponent(
        title
      )}`;

      const res = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (res.data.status) {
        const options = res.data.data.map((item) => ({
          label: item.title,
          value: item.id,
        }));
        setGroups(options);
      }
    } catch (err) {
      responseHandler(err, 'error');
    }
  };

  useEffect(() => {
    fetchGroups();
  }, []);

  const debouncedFetchGroups = debounce((value) => {
    if (value.length >= 2) {
      fetchGroups(value);
    }
  }, 500);

  const handleInputChangeGroups = (value) => {
    debouncedFetchGroups(value);
  };

  const handleChangeGroups = (selectedOption) => {
    setEditeLanding((prev) => ({
      ...prev,
      access_group_id: selectedOption ? selectedOption.value : null,
    }));
  };

  const checkChanges = () => {
    setCheckBtnEdite(true);

    let bodySend = {};

    for (let item in copyOfData) {
      if (item === 'parameters') {
        if (
          compareObjects(copyOfData[item], editeLanding[item]) ===
          false
        )
          bodySend[item] = editeLanding[item];
      } else {
        if (copyOfData[item] !== editeLanding[item])
          bodySend[item] = editeLanding[item];
      }
    }

    document.getElementById('btnModalAnswer').click();
  };

  const [isLoadForModalCheck, setIsLoadForModalCheck] =
    useState(true);
  const [dataForModalCheck, setDataForModalCheck] = useState(null);

  const showAwnserForLanding = () => {
    setIsLoadForModalCheck(true);

    if (
      !editeLanding.parameters.type &&
      !editeLanding.parameters.token
    ) {
      setDataForModalCheck({ count: 0 });
      setIsLoadForModalCheck(false);
      setCheckBtnEdite(false);
    } else {
      const body = {
        type: editeLanding.parameters.type,
        token: editeLanding.parameters.token,
      };

      axios
        .post(`/landing/get-token-type-count`, body, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          if (res.data.status) {
            setDataForModalCheck(res.data.data);
            setIsLoadForModalCheck(false);
            setCheckBtnEdite(false);
          } else {
            notify(res.data.message, 'error');
            setCheckBtnEdite(false);
          }
        })
        .catch((error) => {
          responseHandler(error, 'error');
          setCheckBtnEdite(false);
        });
    }
  };

  const handleChange = (index, field, value) => {
    const updated = [...landingsEditable.landings];
    updated[index][field] = value;
    setLandingsEditable((prev) => ({
      ...prev,
      landings: updated,
    }));
  };

  const handleDurationChange = (e, index) => {
    setOthersParametersEditable((prev) => {
      const updatedvariants = [...prev.variants];

      updatedvariants[index] = {
        ...updatedvariants[index],
        time_change: e.target.value,
        view_change: '',
      };

      return {
        ...prev,
        variants: updatedvariants,
      };
    });
  };

  const handlePriority = (e, index) => {
    setOthersParametersEditable((prev) => {
      const updatedvariants = [...prev.variants];
      updatedvariants[index] = {
        ...updatedvariants[index],
        priority: e.target.value,
      };

      return {
        ...prev,
        variants: updatedvariants,
      };
    });
  };

  const handlePriorityLanding = (value, index) => {
    setLandingsEditable((prev) => {
      const updatedLandings = [...(landingsEditable?.landings || [])];

      updatedLandings[index] = {
        ...updatedLandings[index],
        priority: value,
      };

      return {
        ...prev,

        landings: updatedLandings,
      };
    });
  };

  const handleChangeTimeLanding = (value, index) => {
    setLandingsEditable((prev) => {
      const updatedLandings = [...(landingsEditable?.landings || [])];

      updatedLandings[index] = {
        ...updatedLandings[index],
        time_change: value,
        view_change: '',
      };

      return {
        ...prev,
        landings: updatedLandings,
      };
    });
    setEditeLanding({
      ...editeLanding,
      time_change: value,
    });
  };

  const handleChangeViewLanding = (value, index) => {
    setLandingsEditable((prev) => {
      const updatedLandings = [...(landingsEditable?.landings || [])];

      updatedLandings[index] = {
        ...updatedLandings[index],
        view_change: value,
        time_change: '',
      };

      return {
        ...prev,

        landings: updatedLandings,
      };
    });
  };

  const handleAddGroup = () => {
    setLandingsEditable((prev) => {
      return {
        ...prev,

        landings: [
          ...prev.landings,
          { id: '', priority: '', time_change: '' },
        ],
      };
    });
  };

  const handleViewChange = (e, index) => {
    setOthersParametersEditable((prev) => {
      const updatedvariants = [...prev.variants];

      updatedvariants[index] = {
        ...updatedvariants[index],
        view_change: e.target.value,
        time_change: '',
      };

      return {
        ...prev,
        variants: updatedvariants,
      };
    });
  };

  const colorHandlerOthers = (e, name, type, key) => {
    setOthersParametersEditable((prev) => {
      const updatedVariants = [...prev.variants];

      if (!updatedVariants[key].parameters) {
        updatedVariants[key].parameters = {};
      }

      if (type === 'input') {
        updatedVariants[key].parameters[name] = e.target.value;
      } else {
        updatedVariants[key].parameters[name] = e;
      }

      return {
        ...prev,
        variants: updatedVariants,
      };
    });
  };

  const inputParaHandlerOthers = (e, key) => {
    const { name, value } = e.target;

    const first = changeFaToEn(value);

    setOthersParametersEditable((prev) => {
      const updatedVariants = [...prev.variants];

      if (!updatedVariants[key]?.parameters) {
        updatedVariants[key].parameters = {};
      }

      updatedVariants[key].parameters[name] = first;

      return {
        ...prev,
        variants: updatedVariants,
      };
    });
  };

  const inputParaHandlerOthers2 = (e, index) => {
    const { name, value } = e.target;

    const first = changeFaToEn(value);

    setOthersParametersEditable((prev) => {
      const updatedVariants = [...prev.variants];

      if (!updatedVariants[index]?.parameters) {
        updatedVariants[index].parameters = {};
      }

      updatedVariants[index].parameters[name] = first;

      return {
        ...prev,
        variants: updatedVariants,
      };
    });
  };

  const handleCtrTargetParameters = (e) => {
    setEditeLanding((prev) => ({
      ...prev,
      parameter_group: {
        ...prev.parameter_group,
        CTR_target: e.target.value,
      },
    }));
  };

  useEffect(() => {
    if (editeLanding?.parameter_group?.variants) {
      const onlyParameters =
        editeLanding?.parameter_group?.variants.filter(
          (item) => item.priority != 1
        );
      const cleanedVariants = onlyParameters.map((variant) => ({
        view_change: variant.view_change,
        time_change: variant.time_change,
        parameters:
          typeof variant.parameters === 'string'
            ? JSON.parse(variant.parameters)
            : variant.parameters,
        priority: variant.priority,
      }));

      setOthersParameters({
        ...othersParameters,
        variants: cleanedVariants,
      });
    }

    if (editeLanding?.landing_group?.[0]?.groups) {
      const onlyLanding =
        editeLanding?.landing_group?.[0]?.groups.filter(
          (item) => item?.pivot?.priority != 1
        );
      const cleanedLandings = onlyLanding?.map((variant) => ({
        view_change: variant?.pivot?.view_change,
        time_change: variant?.pivot?.time_change,
        priority: variant?.pivot?.priority,
        id: variant.landing_id,
      }));

      setLandings({
        ...landings,
        CTR_target: editeLanding.landing_group[0].CTR_target,
        change_type: editeLanding.landing_group[0].change_type,
        landings: cleanedLandings,
      });
    }
  }, [
    editeLanding?.parameter_group?.variants,
    editeLanding?.landing_group?.[0]?.groups,
  ]);

  useEffect(() => {
    if (othersParameters?.variants?.length) {
      const filtredMainPara =
        editeLanding?.parameter_group?.variants?.filter(
          (item) => item.priority == 1
        );

      setMainPara(filtredMainPara);
    }
    if (othersParametersEditable?.variants?.length) {
      const copies = othersParametersEditable?.variants.map(() => {
        return dataOfTemplate;
      });

      setTemplateCopies(copies);
    }

    if (landings?.landings?.length) {
      const filtredlandPara =
        editeLanding?.landing_group?.[0]?.groups.filter(
          (item) => item?.pivot?.priority == 1
        );

      setMainLand(filtredlandPara);
    }
  }, [
    dataOfTemplate,
    othersParameters?.variants,
    othersParametersEditable?.variants,
    landings?.landings,
  ]);

  useEffect(() => {
    const filtredUnEditablePara =
      editeLanding?.parameter_group?.variants?.filter(
        (item) => item.priority != 1
      );

    setUnEditableParameter(filtredUnEditablePara);
  }, [dataOfTemplate, editeLanding?.parameter_group?.variants]);

  useEffect(() => {
    if (editeLanding?.landing_group?.[0]?.groups) {
      setUnEditableLand(editeLanding?.landing_group?.[0]?.groups);
    }
  }, [editeLanding?.landing_group?.[0]?.groups]);

  useEffect(() => {
    if (unEditableParameter?.length > 0) {
      const copies = unEditableParameter?.map(() => {
        return dataOfTemplate;
      });

      setTemplateCopiesUnEditable(copies);
    }
  }, [unEditableParameter]);

  const addParameters = (sourceKey = null) => {
    const myParameters = editeLanding?.parameters;

    setParamIndex((prev) => {
      const nextIndex = prev + 1;

      setOthersParametersEditable((othersPrev) => {
        const source =
          sourceKey && othersPrev?.variants?.length
            ? othersPrev.variants.find((v) => v[sourceKey])?.[
                sourceKey
              ]
            : myParameters;

        const newVariant = {
          parameters: JSON.parse(JSON.stringify(source)),
          priority: '',
          time_change: '',
          view_change: '',
        };

        return {
          ...othersPrev,
          variants: [...(othersPrev.variants || []), newVariant],
        };
      });

      return nextIndex;
    });
  };

  const removeParameter = (indexToRemove) => {
    setOthersParametersEditable((prev) => {
      const updatedVariants = prev.variants.filter(
        (_, index) => index !== indexToRemove
      );

      return {
        ...prev,
        variants: updatedVariants,
      };
    });

    setTemplateCopies((prevCopies) => {
      return prevCopies.filter((_, index) => index !== indexToRemove);
    });
  };

  const removeParameterUnEditable = (item, indexToRemove) => {
    setDelete((prev) => [...prev, item]);

    setTemplateCopiesUnEditable((prevCopies) => {
      const updatedEntries = Object.entries(prevCopies).filter(
        (_, index) => index !== indexToRemove
      );

      return Object.fromEntries(updatedEntries);
    });

    setUnEditableParameter((prev) => {
      const newArray = [...prev];
      newArray.splice(indexToRemove, 1);
      return newArray;
    });
  };

  useEffect(() => {
    if (othersParametersEditable.variants.length > 0) {
      setOthersParameters((prev) => ({
        ...prev,
        variants: [
          ...prev.variants,
          ...othersParametersEditable.variants,
        ],
      }));
    }
  }, [othersParametersEditable.variants]);

  useEffect(() => {
    setLandings((prev) => {
      return {
        ...prev,
        landings: [...prev.landings, ...landingsEditable.landings],
      };
    });
  }, [landingsEditable]);

  const handleCtrTarget = (e) => {
    setLandings((prev) => ({
      ...prev,
      CTR_target: e.target.value,
    }));
  };

  return !isLoad && isLogin ? (
    <>
      <div className={styles.EditeLanding}>
        <div className={copyOfInstallLanding.title}>
          <span>{`ویرایش لندینگ   ${copyOfData.title}`}</span>
          <i className="bi bi-gear-wide"></i>
        </div>

        <div className={copyOfInstallLanding.consts}>
          <div className={copyOFNewUserModal.Inputs}>
            <label htmlFor="EditetitleLanding">عنوان لندینگ:</label>
            <input
              type="text"
              id="EditetitleLanding"
              name="title"
              value={editeLanding.title}
              onChange={inputHandler}
            />
          </div>

          <div className={copyOFNewUserModal.Inputs}>
            <label htmlFor="EditeslugLanding">آدرس لندینگ:</label>
            <input
              type="text"
              id="EditeslugLanding"
              name="slug"
              value={editeLanding.slug}
              onChange={inputHandler}
            />
          </div>

          <div className={copyOFNewUserModal.Inputs}>
            <label htmlFor="childLanding">
              آیا این لندینگ فرزند است؟
            </label>
            <select
              disabled={editeLanding.is_child == 1 ? true : false}
              className={`${styles.SelectPanel} form-select`}
              value={editeLanding?.is_child}
              onChange={(e) => {
                const value = e.target.value;
                setEditeLanding((prev) => ({
                  ...prev,
                  is_child: value,
                }));
              }}
            >
              <option value={0}>خیر</option>
              <option value={1}>بله</option>
            </select>
          </div>

          <div className={copyOFNewUserModal.Inputs}>
            <label htmlFor="slugLanding">
              آیا نیاز به لندینگ پیشرفته دارید؟
            </label>
            <select
              disabled={!mainPara?.[0] ? false : true}
              className={`${styles.SelectPanel} form-select`}
              value={mainPara?.[0] || advance == 1 ? 1 : 0}
              onChange={(e) => {
                const value = e.target.value;
                setAdvance(value);
              }}
            >
              <option value={0}>خیر</option>
              <option value={1}>بله</option>
            </select>
          </div>

          {groups?.length > 0 && (
            <div>
              <div
                style={{
                  marginBottom: 20,
                  marginTop: 10,
                }}
              >
                <label htmlFor="slugLanding">انتخاب گروه :</label>
                <CustomSelect
                  options={groups}
                  placeholder="گروه را انتخاب کنید"
                  onInputChange={handleInputChangeGroups}
                  onChange={handleChangeGroups}
                  isClearable
                  isSearchable
                  value={
                    groups.find(
                      (o) => o.value === editeLanding.access_group_id
                    ) || null
                  }
                />
              </div>
            </div>
          )}
        </div>

        <div className={copyOfInstallLanding.titleTopAccordion}>
          <span>پارامتر ها</span>
        </div>

        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
          }}
        >
          <div style={{ minWidth: '30%' }} className={styles.ParaDiv}>
            <div className={styles.toptext}>
              <label className={styles.ParaName}>هدف CTR</label>
              <span className={styles.paraDec}>
                درصد CTR مورد نظر را وارد کنید(فقط عدد)
              </span>
            </div>
            <input
              value={editeLanding?.parameter_group?.CTR_target}
              readOnly={!mainPara?.[0] ? false : true}
              type="text"
              onChange={(e) => handleCtrTargetParameters(e)}
            />
          </div>
          <div style={{ minWidth: '30%' }} className={styles.ParaDiv}>
            <div className={styles.toptext}>
              <label className={styles.ParaName}>CTR براساس:</label>
              <span className={styles.paraDec}>
                براساس تعداد بازدید یا مدت زمان
              </span>
            </div>
            <select
              disabled={!mainPara?.[0] ? false : true}
              className={`${styles.SelectPanel} form-select`}
              value={editeLanding?.parameter_group?.view_change}
              onChange={(e) => {
                const value = e.target.value;
                setEditeLanding((prev) => ({
                  ...prev,
                  parameter_group: {
                    ...prev.parameter_group,
                    change_type: value,
                  },
                }));
              }}
            >
              <option value="view_change">تعداد بازدید</option>
              <option value="time_change">مدت زمان</option>
            </select>
          </div>

          {editeLanding?.parameter_group?.change_type ===
          'time_change' ? (
            <div
              style={{ minWidth: '30%' }}
              className={styles.ParaDiv}
            >
              <div className={styles.toptext}>
                <label className={styles.ParaName}>مدت زمان</label>
                <span className={styles.paraDec}>
                  مدت زمان مورد نظر برای محاسبه CTR(دقیقه)
                </span>
              </div>
              <input
                readOnly={!mainPara?.[0] ? false : true}
                value={mainPara?.[0]?.time_change}
                type="text"
                onChange={(e) => {
                  const value = e.target.value;
                  setEditeLanding((prev) => ({
                    ...prev,
                    parameter_change: value,
                  }));
                }}
              />
            </div>
          ) : (
            <div
              style={{ minWidth: '30%' }}
              className={styles.ParaDiv}
            >
              <div className={styles.toptext}>
                <label className={styles.ParaName}>
                  تعداد بازدید
                </label>
                <span className={styles.paraDec}>
                  تعداد بازدید مورد نظر برای محاسبه CTR
                </span>
              </div>
              <input
                disabled={!mainPara?.[0] ? false : true}
                value={mainPara?.[0]?.view_change}
                type="text"
                onChange={(e) => {
                  const value = e.target.value;
                  setEditeLanding((prev) => ({
                    ...prev,
                    parameter_change: value,
                  }));
                }}
              />
            </div>
          )}
        </div>

        <div className="accordion " id="accordionExample">
          {dataOfTemplate
            ?.filter((item) => {
              if (user.is_admin == 1 || isAccess || !mainPara?.[0])
                return true;
              return (
                item.groupName === 'کادر موبایل' ||
                item.groupName === 'ملزومات لندینگ'
              );
            })
            .map((item, index) => {
              return (
                <React.Fragment key={item.groupId}>
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <button
                        className="accordion-button"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={`#collapse${item.groupId}`}
                        aria-expanded="true"
                        aria-controls={`collapse${item.groupId}`}
                      >
                        {item.groupName}
                      </button>
                    </h2>

                    <div
                      id={`collapse${item.groupId}`}
                      className={`accordion-collapse collapse ${
                        index + 1 === dataOfTemplate.length && 'show'
                      }`}
                    >
                      <div
                        className={`accordion-body ${copyOfInstallLanding.bodyOfAccordion}`}
                      >
                        {item.parameters.map(
                          (paraItem, paraIndex) => {
                            const valuePara =
                              editeLanding.parameters[
                                paraItem.paraName
                              ];

                            return (
                              <div
                                key={`${item.groupId}${paraItem.paraId}`}
                              >
                                <div
                                  className={
                                    copyOfInstallLanding.ParaDiv
                                  }
                                >
                                  <div
                                    className={
                                      copyOfInstallLanding.toptext
                                    }
                                  >
                                    <label
                                      className={
                                        copyOfInstallLanding.ParaName
                                      }
                                      htmlFor={`${item.groupId}${paraItem.paraId}`}
                                    >
                                      {paraItem.paraName}
                                    </label>
                                    <span
                                      className={
                                        copyOfInstallLanding.paraDec
                                      }
                                    >
                                      {paraItem.paraDescription}
                                    </span>
                                  </div>

                                  {paraItem.paraType !== 'select' ? (
                                    paraItem.paraType === 'color' ? (
                                      <div
                                        className={
                                          styles.divInputPicker
                                        }
                                      >
                                        <div
                                          id="test"
                                          className={styles.Picker}
                                          onMouseLeave={(e) =>
                                            ColorPickerShowHandler(
                                              e,
                                              'leave'
                                            )
                                          }
                                        >
                                          <HexColorPicker
                                            color={valuePara}
                                            onChange={(e) =>
                                              colorHandler(
                                                e,
                                                paraItem.paraName,
                                                'picker'
                                              )
                                            }
                                          />
                                        </div>

                                        <div
                                          className={styles.showcolor}
                                          style={{
                                            backgroundColor:
                                              valuePara ??
                                              'transparent',
                                          }}
                                          onClick={(e) =>
                                            ColorPickerShowHandler(
                                              e,
                                              'enter'
                                            )
                                          }
                                        ></div>
                                        <input
                                          value={valuePara}
                                          placeholder={
                                            valuePara === ''
                                              ? 'اکنون رنگ پیشفرض قالب است'
                                              : ''
                                          }
                                          maxLength={9}
                                          onChange={(e) =>
                                            colorHandler(
                                              e,
                                              paraItem.paraName,
                                              'input'
                                            )
                                          }
                                        />
                                      </div>
                                    ) : paraItem.paraDescription ===
                                      'توکن وب سرویس' ? (
                                      <input
                                        type={paraItem.paraType}
                                        id={`${item.groupId}${paraItem.paraId}${paramIndex}`}
                                        name={paraItem.paraName}
                                        value={valuePara}
                                        onChange={inputParaHandler2}
                                      />
                                    ) : paraItem.paraDescription ===
                                      'تایپ لندینگ' ? (
                                      <input
                                        type={paraItem.paraType}
                                        id={`${item.groupId}${paraItem.paraId}`}
                                        name={paraItem.paraName}
                                        value={valuePara}
                                        onChange={inputParaHandler3}
                                      />
                                    ) : (
                                      <input
                                        type={paraItem.paraType}
                                        id={`${item.groupId}${paraItem.paraId}`}
                                        name={paraItem.paraName}
                                        value={
                                          editeLanding.parameters[
                                            paraItem.paraName
                                          ]
                                        }
                                        onChange={inputParaHandler}
                                      />
                                    )
                                  ) : paraItem.paraName !== 'type' ? (
                                    <select
                                      className={`${styles.SelectPanel} form-select`}
                                      name={`${paraItem.paraName}Select`}
                                      value={
                                        paraItem.ParaName === 'type'
                                          ? editeLanding.parameters[
                                              `${paraItem.paraName}`
                                            ]
                                          : editeLanding.parameters[
                                              `${paraItem.paraName}Select`
                                            ]
                                      }
                                      onChange={inputParaHandler}
                                    >
                                      <option value="">
                                        {'انتخاب نشده'}
                                      </option>
                                      {selectOptions[
                                        `${paraItem.paraName}`
                                      ]?.map((itemOp, indexOp) => {
                                        return (
                                          <option
                                            key={indexOp}
                                            value={itemOp.id}
                                          >
                                            {itemOp.name}
                                          </option>
                                        );
                                      })}
                                    </select>
                                  ) : (
                                    <Select
                                      showSearch
                                      style={{ width: 200 }}
                                      placeholder={
                                        paraItem.paraName ===
                                          'type' && loadingType
                                          ? 'صبر کنید...'
                                          : 'انتخاب نشده'
                                      }
                                      optionFilterProp="label"
                                      filterSort={(
                                        optionA,
                                        optionB
                                      ) =>
                                        (optionA?.label ?? '')
                                          .toLowerCase()
                                          .localeCompare(
                                            (
                                              optionB?.label ?? ''
                                            ).toLowerCase()
                                          )
                                      }
                                      value={
                                        editeLanding?.parameters?.[
                                          `${paraItem.paraName}`
                                        ] || undefined
                                      }
                                      onChange={(value) =>
                                        inputParaHandler({
                                          target: {
                                            name: `${paraItem.paraName}Select`,
                                            value,
                                          },
                                        })
                                      }
                                      allowClear
                                      options={[
                                        ...(selectOptions?.[
                                          paraItem.paraName
                                        ]?.map((itemOp) => ({
                                          value:
                                            paraItem.paraName ===
                                            'type'
                                              ? itemOp
                                              : itemOp.id,
                                          label:
                                            paraItem.paraName ===
                                            'type'
                                              ? itemOp
                                              : itemOp.name,
                                        })) || []),
                                      ].filter(
                                        (value, index, self) =>
                                          index ===
                                          self.findIndex(
                                            (t) =>
                                              t.value === value.value
                                          )
                                      )}
                                    />
                                  )}
                                </div>
                              </div>
                            );
                          }
                        )}
                      </div>
                    </div>
                  </div>
                </React.Fragment>
              );
            })}

          {Object.entries(templateCopiesUnEditable)?.map(
            ([key, groups], indexa) => (
              <div
                key={key}
                style={{ backgroundColor: '#eee' }}
                className="mb-6 border p-4 m-4 rounded"
              >
                <h2 className="text-lg font-bold mb-2">{`پارامترها ${
                  indexa + 2
                }`}</h2>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    flexWrap: 'wrap',
                  }}
                >
                  {editeLanding?.parameter_group?.change_type ===
                  'time_change' ? (
                    <div
                      style={{ width: '45%', minWidth: '220px' }}
                      className={styles.ParaDiv}
                    >
                      <div className={styles.toptext}>
                        <label className={styles.ParaName}>
                          مدت زمان
                        </label>
                        <span className={styles.paraDec}>
                          مدت زمان مورد نظر برای محاسبه CTR(دقیقه)
                        </span>
                      </div>
                      <input
                        value={
                          unEditableParameter?.[indexa]?.time_change
                        }
                        type="text"
                        readOnly
                      />
                    </div>
                  ) : (
                    <div
                      style={{ width: '45%', minWidth: '220px' }}
                      className={styles.ParaDiv}
                    >
                      <div className={styles.toptext}>
                        <label className={styles.ParaName}>
                          تعداد بازدید
                        </label>
                        <span className={styles.paraDec}>
                          تعداد بازدید مورد نظر برای محاسبه CTR
                        </span>
                      </div>
                      <input
                        value={
                          unEditableParameter?.[indexa]?.view_change
                        }
                        type="text"
                        readOnly
                      />
                    </div>
                  )}
                  <div
                    style={{ minWidth: '45%' }}
                    className={styles.ParaDiv}
                  >
                    <div className={styles.toptext}>
                      <label className={styles.ParaName}>الویت</label>
                      <span className={styles.paraDec}>
                        {`
                          الویت از ${paraPriority + 1} شروع میشود
                          `}
                      </span>
                    </div>
                    <input
                      onWheel={(e) => e.target.blur()}
                      value={unEditableParameter?.[indexa]?.priority}
                      type="number"
                      min={2}
                      readOnly
                    />
                  </div>
                </div>
                {groups
                  ?.filter((item) => {
                    if (
                      user.is_admin == 1 ||
                      isAccess ||
                      !mainPara?.[0]
                    )
                      return true;

                    return (
                      item.groupName === 'کادر موبایل' ||
                      item.groupName === 'ملزومات لندینگ'
                    );
                  })
                  .map((item, index) => (
                    <React.Fragment key={item.groupId}>
                      <div className="accordion-item">
                        <h2 className="accordion-header">
                          <button
                            className="accordion-button"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target={`#collapse${item.groupId}${paramIndex}`}
                            aria-expanded="true"
                            aria-controls={`collapse${item.groupId}${paramIndex}`}
                          >
                            {item.groupName}
                          </button>
                        </h2>

                        <div
                          id={`collapse${item.groupId}${paramIndex}`}
                          className={`accordion-collapse collapse ${
                            index + 1 === dataOfTemplate.length &&
                            'show'
                          }`}
                        >
                          <div
                            className={`accordion-body ${styles.bodyOfAccordion}`}
                          >
                            {item.parameters?.map(
                              (paraItem, paraIndex) => {
                                const jsonPara =
                                  typeof unEditableParameter?.[indexa]
                                    ?.parameters === 'string'
                                    ? JSON.parse(
                                        unEditableParameter?.[indexa]
                                          ?.parameters
                                      )
                                    : unEditableParameter?.[indexa]
                                        ?.parameters;
                                const valuePara =
                                  jsonPara?.[paraItem?.paraName];

                                return (
                                  <div
                                    key={`${item.groupId}${paraItem.paraId}${paramIndex}`}
                                  >
                                    <div className={styles.ParaDiv}>
                                      <div className={styles.toptext}>
                                        <label
                                          className={styles.ParaName}
                                          htmlFor={`${item.groupId}${paraItem.paraId}${paramIndex}`}
                                        >
                                          {paraItem.paraName}
                                        </label>
                                        <span
                                          className={styles.paraDec}
                                        >
                                          {paraItem.paraDescription}
                                        </span>
                                      </div>

                                      {paraItem.paraType !==
                                      'select' ? (
                                        paraItem.paraType ===
                                        'color' ? (
                                          <div
                                            className={
                                              styles.divInputPicker
                                            }
                                          >
                                            <div
                                              id={`test${paramIndex}`}
                                              className={
                                                styles.Picker
                                              }
                                              onMouseLeave={(e) =>
                                                ColorPickerShowHandler(
                                                  e,
                                                  'leave'
                                                )
                                              }
                                            >
                                              <HexColorPicker
                                                disabled
                                                color={valuePara}
                                              />
                                            </div>

                                            <div
                                              className={
                                                styles.showcolor
                                              }
                                              style={{
                                                backgroundColor:
                                                  valuePara ??
                                                  'transparent',
                                              }}
                                            ></div>
                                            <input
                                              value={valuePara}
                                              placeholder={
                                                valuePara === ''
                                                  ? 'اکنون رنگ پیشفرض قالب است'
                                                  : ''
                                              }
                                              maxLength={9}
                                              readOnly
                                            />
                                          </div>
                                        ) : paraItem.paraDescription ===
                                          'توکن وب سرویس' ? (
                                          <input
                                            type={paraItem.paraType}
                                            id={`${item.groupId}${paraItem.paraId}${paramIndex}`}
                                            name={paraItem.paraName}
                                            value={valuePara}
                                            readOnly
                                          />
                                        ) : (
                                          <input
                                            type={paraItem.paraType}
                                            id={`${item.groupId}${paraItem.paraId}${paramIndex}`}
                                            name={paraItem.paraName}
                                            value={valuePara}
                                            readOnly
                                          />
                                        )
                                      ) : paraItem.paraName !==
                                        'type' ? (
                                        <select
                                          disabled
                                          isSearchable
                                          className={`${styles.SelectPanel} form-select`}
                                          name={paraItem.paraName}
                                        >
                                          <option value="">
                                            {paraItem.paraName ===
                                              'type' && loadingType
                                              ? 'صبر کنید...'
                                              : 'انتخاب نشده'}
                                          </option>
                                          {selectOptions[
                                            `${paraItem.paraName}`
                                          ]?.map(
                                            (itemOp, indexOp) => {
                                              return paraItem.paraName ===
                                                'type' ? (
                                                <option
                                                  key={indexOp}
                                                  value={itemOp}
                                                >
                                                  {itemOp}
                                                </option>
                                              ) : (
                                                <option
                                                  key={indexOp}
                                                  value={itemOp.id}
                                                >
                                                  {itemOp.name}
                                                </option>
                                              );
                                            }
                                          )}
                                        </select>
                                      ) : (
                                        <Select
                                          disabled
                                          showSearch
                                          style={{ width: 200 }}
                                          optionFilterProp="label"
                                          filterOption={(
                                            input,
                                            option
                                          ) =>
                                            option.label
                                              .toLowerCase()
                                              .includes(
                                                input.toLowerCase()
                                              )
                                          }
                                          filterSort={(
                                            optionA,
                                            optionB
                                          ) =>
                                            (optionA?.label ?? '')
                                              .toLowerCase()
                                              .localeCompare(
                                                (
                                                  optionB?.label ?? ''
                                                ).toLowerCase()
                                              )
                                          }
                                          loading={loadingType}
                                          value={valuePara}
                                          allowClear
                                          options={
                                            [
                                              ...new Set(
                                                selectOptions?.[
                                                  paraItem.paraName
                                                ] || []
                                              ),
                                            ]?.map((itemOp) => ({
                                              value: itemOp,
                                              label: itemOp,
                                            })) || []
                                          }
                                        />
                                      )}
                                    </div>
                                  </div>
                                );
                              }
                            )}
                          </div>
                        </div>
                      </div>
                    </React.Fragment>
                  ))}
                <button
                  style={{ margin: 20, padding: 5, width: 220 }}
                  className="btn btn-danger ms-2"
                  onClick={() => {
                    removeParameterUnEditable(
                      unEditableParameter?.[indexa]?.id,
                      indexa
                    );
                    notify(`پارامتر حذف شد.`, 'error');
                  }}
                >
                  <i className="bi bi-trash"></i>
                  <span style={{ padding: 10 }}>{`حذف پارامتر`}</span>
                </button>
              </div>
            )
          )}

          {(advance == 1 || mainPara?.[0]) && (
            <button
              style={{ margin: 20, padding: 5, width: 220 }}
              className="btn btn-warning ms-4"
              onClick={() => {
                addParameters();
              }}
            >
              <i className="bi bi-copy"></i>
              <span style={{ padding: 10 }}>کپی از پارامتر اصلی</span>
            </button>
          )}
          {Object.entries(templateCopies)?.map(
            ([key, groups], indexa) => (
              <div key={key} className="mb-6 border p-4 m-4 rounded">
                <h2 className="text-lg font-bold mb-2">{`پارامترها ${
                  indexa + unEditableParameter?.length + 2
                }`}</h2>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    flexWrap: 'wrap',
                  }}
                >
                  {editeLanding?.parameter_group?.change_type ===
                  'time_change' ? (
                    <div
                      style={{ width: '45%', minWidth: '220px' }}
                      className={styles.ParaDiv}
                    >
                      <div className={styles.toptext}>
                        <label className={styles.ParaName}>
                          مدت زمان
                        </label>
                        <span className={styles.paraDec}>
                          مدت زمان مورد نظر برای محاسبه CTR(دقیقه)
                        </span>
                      </div>
                      <input
                        value={
                          othersParametersEditable?.variants?.[indexa]
                            ?.time_change
                        }
                        type="text"
                        onChange={(e) =>
                          handleDurationChange(e, indexa)
                        }
                      />
                    </div>
                  ) : (
                    <div
                      style={{ width: '45%', minWidth: '220px' }}
                      className={styles.ParaDiv}
                    >
                      <div className={styles.toptext}>
                        <label className={styles.ParaName}>
                          تعداد بازدید
                        </label>
                        <span className={styles.paraDec}>
                          تعداد بازدید مورد نظر برای محاسبه CTR
                        </span>
                      </div>
                      <input
                        value={
                          othersParametersEditable?.variants?.[indexa]
                            ?.view_change
                        }
                        type="text"
                        onChange={(e) => handleViewChange(e, indexa)}
                      />
                    </div>
                  )}
                  <div
                    style={{ minWidth: '45%' }}
                    className={styles.ParaDiv}
                  >
                    <div className={styles.toptext}>
                      <label className={styles.ParaName}>الویت</label>
                      <span className={styles.paraDec}>
                        {`
                          الویت از ${paraPriority + 1} شروع میشود
                          `}
                      </span>
                    </div>
                    <input
                      onWheel={(e) => e.target.blur()}
                      value={
                        othersParametersEditable?.variants?.[indexa]
                          ?.priority
                      }
                      type="number"
                      min={2}
                      onChange={(e) => handlePriority(e, indexa)}
                    />
                  </div>
                </div>
                {groups
                  ?.filter((item) => {
                    if (
                      user.is_admin == 1 ||
                      isAccess ||
                      !mainPara?.[0]
                    )
                      return true;
                    return (
                      item.groupName === 'کادر موبایل' ||
                      item.groupName === 'ملزومات لندینگ'
                    );
                  })
                  .map((item, index) => (
                    <React.Fragment key={item.groupId}>
                      <div className="accordion-item">
                        <h2 className="accordion-header">
                          <button
                            className="accordion-button"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target={`#collapse${item.groupId}${paramIndex}`}
                            aria-expanded="true"
                            aria-controls={`collapse${item.groupId}${paramIndex}`}
                          >
                            {item.groupName}
                          </button>
                        </h2>

                        <div
                          id={`collapse${item.groupId}${paramIndex}`}
                          className={`accordion-collapse collapse ${
                            index + 1 === dataOfTemplate.length &&
                            'show'
                          }`}
                        >
                          <div
                            className={`accordion-body ${styles.bodyOfAccordion}`}
                          >
                            {item.parameters?.map(
                              (paraItem, paraIndex) => {
                                const valuePara =
                                  othersParametersEditable
                                    ?.variants?.[indexa]
                                    ?.parameters?.[
                                    paraItem?.paraName
                                  ];

                                return (
                                  <div
                                    key={`${item.groupId}${paraItem.paraId}${paramIndex}`}
                                  >
                                    <div className={styles.ParaDiv}>
                                      <div className={styles.toptext}>
                                        <label
                                          className={styles.ParaName}
                                          htmlFor={`${item.groupId}${paraItem.paraId}${paramIndex}`}
                                        >
                                          {paraItem.paraName}
                                        </label>
                                        <span
                                          className={styles.paraDec}
                                        >
                                          {paraItem.paraDescription}
                                        </span>
                                      </div>

                                      {paraItem.paraType !==
                                      'select' ? (
                                        paraItem.paraType ===
                                        'color' ? (
                                          <div
                                            className={
                                              styles.divInputPicker
                                            }
                                          >
                                            <div
                                              id={`test${paramIndex}`}
                                              className={
                                                styles.Picker
                                              }
                                              onMouseLeave={(e) =>
                                                ColorPickerShowHandler(
                                                  e,
                                                  'leave'
                                                )
                                              }
                                            >
                                              <HexColorPicker
                                                color={valuePara}
                                                onChange={(e) =>
                                                  colorHandlerOthers(
                                                    e,
                                                    paraItem.paraName,
                                                    'picker',
                                                    key
                                                  )
                                                }
                                              />
                                            </div>

                                            <div
                                              className={
                                                styles.showcolor
                                              }
                                              style={{
                                                backgroundColor:
                                                  valuePara ??
                                                  'transparent',
                                              }}
                                              onClick={(e) =>
                                                ColorPickerShowHandler(
                                                  e,
                                                  'enter'
                                                )
                                              }
                                            ></div>
                                            <input
                                              value={valuePara}
                                              placeholder={
                                                valuePara === ''
                                                  ? 'اکنون رنگ پیشفرض قالب است'
                                                  : ''
                                              }
                                              maxLength={9}
                                              onChange={(e) =>
                                                colorHandlerOthers(
                                                  e,
                                                  paraItem.paraName,
                                                  'input',
                                                  key
                                                )
                                              }
                                            />
                                          </div>
                                        ) : paraItem.paraDescription ===
                                          'توکن وب سرویس' ? (
                                          <input
                                            type={paraItem.paraType}
                                            id={`${item.groupId}${paraItem.paraId}${paramIndex}`}
                                            name={paraItem.paraName}
                                            value={valuePara}
                                            onChange={(e) =>
                                              inputParaHandler2(
                                                e,
                                                key
                                              )
                                            }
                                          />
                                        ) : paraItem.paraDescription ===
                                          'تایپ لندینگ' ? (
                                          <input
                                            type={paraItem.paraType}
                                            id={`${item.groupId}${paraItem.paraId}`}
                                            name={paraItem.paraName}
                                            value={valuePara}
                                            onChange={
                                              inputParaHandler3
                                            }
                                          />
                                        ) : (
                                          <input
                                            type={paraItem.paraType}
                                            id={`${item.groupId}${paraItem.paraId}${paramIndex}`}
                                            name={paraItem.paraName}
                                            value={valuePara || ''}
                                            onChange={(e) =>
                                              inputParaHandlerOthers(
                                                e,
                                                key
                                              )
                                            }
                                          />
                                        )
                                      ) : paraItem.paraName !==
                                        'type' ? (
                                        <select
                                          isSearchable
                                          className={`${styles.SelectPanel} form-select`}
                                          name={paraItem.paraName}
                                        >
                                          <option value="">
                                            {paraItem.paraName ===
                                              'type' && loadingType
                                              ? 'صبر کنید...'
                                              : 'انتخاب نشده'}
                                          </option>
                                          {selectOptions[
                                            `${paraItem.paraName}`
                                          ]?.map(
                                            (itemOp, indexOp) => {
                                              return paraItem.paraName ===
                                                'type' ? (
                                                <option
                                                  key={indexOp}
                                                  value={itemOp}
                                                >
                                                  {itemOp}
                                                </option>
                                              ) : (
                                                <option
                                                  key={indexOp}
                                                  value={itemOp.id}
                                                >
                                                  {itemOp.name}
                                                </option>
                                              );
                                            }
                                          )}
                                        </select>
                                      ) : (
                                        <Select
                                          showSearch
                                          style={{ width: 200 }}
                                          optionFilterProp="label"
                                          filterOption={(
                                            input,
                                            option
                                          ) =>
                                            option.label
                                              .toLowerCase()
                                              .includes(
                                                input.toLowerCase()
                                              )
                                          }
                                          filterSort={(
                                            optionA,
                                            optionB
                                          ) =>
                                            (optionA?.label ?? '')
                                              .toLowerCase()
                                              .localeCompare(
                                                (
                                                  optionB?.label ?? ''
                                                ).toLowerCase()
                                              )
                                          }
                                          loading={loadingType}
                                          value={valuePara}
                                          onChange={(value) =>
                                            inputParaHandlerOthers({
                                              target: {
                                                name: `${paraItem.paraName}Select`,
                                                value,
                                              },
                                              key,
                                            })
                                          }
                                          allowClear
                                          options={
                                            [
                                              ...new Set(
                                                selectOptions?.[
                                                  paraItem.paraName
                                                ] || []
                                              ),
                                            ]?.map((itemOp) => ({
                                              value: itemOp,
                                              label: itemOp,
                                            })) || []
                                          }
                                        />
                                      )}
                                    </div>
                                  </div>
                                );
                              }
                            )}
                          </div>
                        </div>
                      </div>
                    </React.Fragment>
                  ))}
              </div>
            )
          )}

          {editeLanding.is_child != 1 && (
            <div className="accordion-item">
              <h2 className="accordion-header">
                <button
                  className="accordion-button"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target={`#collapse`}
                  aria-expanded="true"
                  aria-controls="collapseOne"
                >
                  گروه‌های لندینگ
                </button>
              </h2>
              <div
                id={`collapse`}
                className={`accordion-collapse collapse`}
              >
                <div className={`accordion-body `}>
                  {!mainLand?.[0] &&
                  landingsEditable?.landings?.length ? (
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        flexWrap: 'wrap',
                      }}
                    >
                      <div
                        style={{ minWidth: '30%' }}
                        className={styles.ParaDiv}
                      >
                        <div className={styles.toptext}>
                          <label className={styles.ParaName}>
                            هدف CTR
                          </label>
                          <span className={styles.paraDec}>
                            درصد CTR مورد نظر را وارد کنید(فقط عدد)
                          </span>
                        </div>
                        <input
                          value={landings?.CTR_target}
                          type="text"
                          onChange={(e) => handleCtrTarget(e)}
                        />
                      </div>
                      <div
                        style={{ minWidth: '30%' }}
                        className={styles.ParaDiv}
                      >
                        <div className={styles.toptext}>
                          <label className={styles.ParaName}>
                            CTR براساس:
                          </label>
                          <span className={styles.paraDec}>
                            براساس تعداد بازدید یا مدت زمان
                          </span>
                        </div>
                        <select
                          className={`${styles.SelectPanel} form-select`}
                          value={landings?.change_type}
                          onChange={(e) => {
                            const value = e.target.value;
                            setLandings((prev) => ({
                              ...prev,
                              change_type: value,
                            }));
                          }}
                        >
                          <option value="">انتخاب کنید</option>
                          <option value="view_change">
                            تعداد بازدید
                          </option>
                          <option value="time_change">
                            مدت زمان
                          </option>
                        </select>
                      </div>
                      {landings?.change_type === 'time_change' ? (
                        <div
                          style={{ minWidth: '30%' }}
                          className={styles.ParaDiv}
                        >
                          <div className={styles.toptext}>
                            <label className={styles.ParaName}>
                              مدت زمان
                            </label>
                            <span className={styles.paraDec}>
                              بعد از چه مدت زمانی CTR محاسبه شود؟
                            </span>
                          </div>
                          <input
                            value={mainLand?.[0]?.time_change}
                            type="text"
                            onChange={(e) =>
                              setEditeLanding((prev) => {
                                return {
                                  ...prev,
                                  view_change: '',
                                  time_change: e.target.value,
                                };
                              })
                            }
                          />
                        </div>
                      ) : (
                        <div
                          style={{ minWidth: '30%' }}
                          className={styles.ParaDiv}
                        >
                          <div className={styles.toptext}>
                            <label className={styles.ParaName}>
                              تعداد بازدید
                            </label>
                            <span className={styles.paraDec}>
                              بعد از چه تعداد بازدید CTR لندینگ اصلی
                              محاسبه شود؟
                            </span>
                          </div>
                          <input
                            value={mainLand?.[0]?.view_change}
                            type="text"
                            onChange={(e) =>
                              setEditeLanding((prev) => {
                                return {
                                  ...prev,
                                  time_change: '',
                                  view_change: e.target.value,
                                };
                              })
                            }
                          />
                        </div>
                      )}
                    </div>
                  ) : (
                    unEditableLand?.length > 0 && (
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          flexWrap: 'wrap',
                        }}
                      >
                        <div
                          style={{ minWidth: '30%' }}
                          className={styles.ParaDiv}
                        >
                          <div className={styles.toptext}>
                            <label className={styles.ParaName}>
                              هدف CTR
                            </label>
                            <span className={styles.paraDec}>
                              درصد CTR مورد نظر را وارد کنید(فقط عدد)
                            </span>
                          </div>
                          <input
                            value={landings?.CTR_target}
                            type="text"
                            readOnly
                          />
                        </div>
                        <div
                          style={{ minWidth: '30%' }}
                          className={styles.ParaDiv}
                        >
                          <div className={styles.toptext}>
                            <label className={styles.ParaName}>
                              CTR براساس:
                            </label>
                            <span className={styles.paraDec}>
                              براساس تعداد بازدید یا مدت زمان
                            </span>
                          </div>
                          <select
                            className={`${styles.SelectPanel} form-select`}
                            value={landings?.change_type}
                            disabled
                          >
                            <option value="">انتخاب کنید</option>
                            <option value="view_change">
                              تعداد بازدید
                            </option>
                            <option value="time_change">
                              مدت زمان
                            </option>
                          </select>
                        </div>
                        {landings?.change_type === 'time_change' ? (
                          <div
                            style={{ minWidth: '30%' }}
                            className={styles.ParaDiv}
                          >
                            <div className={styles.toptext}>
                              <label className={styles.ParaName}>
                                مدت زمان
                              </label>
                              <span className={styles.paraDec}>
                                بعد از چه مدت زمانی CTR محاسبه شود؟
                              </span>
                            </div>
                            <input
                              value={
                                mainLand?.[0]?.pivot?.time_change
                              }
                              type="text"
                              readOnly
                            />
                          </div>
                        ) : (
                          <div
                            style={{ minWidth: '30%' }}
                            className={styles.ParaDiv}
                          >
                            <div className={styles.toptext}>
                              <label className={styles.ParaName}>
                                تعداد بازدید
                              </label>
                              <span className={styles.paraDec}>
                                بعد از چه تعداد بازدید CTR لندینگ اصلی
                                محاسبه شود؟
                              </span>
                            </div>
                            <input
                              value={
                                mainLand?.[0]?.pivot?.view_change
                              }
                              type="text"
                              readOnly
                            />
                          </div>
                        )}
                      </div>
                    )
                  )}

                  <h2 style={{ padding: 10, margin: 5 }}>
                    زیرمجموعه ها
                  </h2>
                  {unEditableLand?.length > 0 &&
                    unEditableLand?.map((item, index) => (
                      <div
                        key={index}
                        style={{
                          backgroundColor: '#eee',
                          display: 'flex',
                          flexDirection: 'row',
                          flexWrap: 'wrap',
                        }}
                      >
                        <div
                          style={{ minWidth: '30%' }}
                          className={styles.ParaDiv}
                        >
                          <div className={styles.toptext}>
                            <label
                              className={styles.ParaName}
                              htmlFor={`id-${index}`}
                            >
                              {`زیرمجموعه ${index + 1}`}
                            </label>
                            <span className={styles.paraDec}>
                              لندینگ فرزند
                            </span>
                          </div>
                          <input value={item.landing_slug} readOnly />
                        </div>

                        <div
                          style={{ minWidth: '30%' }}
                          className={styles.ParaDiv}
                        >
                          <div className={styles.toptext}>
                            <label
                              className={styles.ParaName}
                              htmlFor={`priority-${index}`}
                            >
                              الویت
                            </label>
                            <span className={styles.paraDec}>
                              {`
                            الویت از ${landPriority + 1} شروع میشود
                            `}
                            </span>
                          </div>
                          <input
                            onWheel={(e) => e.target.blur()}
                            value={item?.pivot?.priority}
                            type="number"
                            min={2}
                            readOnly
                          />
                        </div>

                        {landings?.change_type === 'time_change' ? (
                          <div
                            style={{ minWidth: '30%' }}
                            className={styles.ParaDiv}
                          >
                            <div className={styles.toptext}>
                              <label className={styles.ParaName}>
                                مدت زمان
                              </label>
                              <span className={styles.paraDec}>
                                بعد از چه مدت زمانی CTR محاسبه شود؟
                              </span>
                            </div>
                            <input
                              value={item?.pivot?.time_change}
                              type="text"
                              readOnly
                            />
                          </div>
                        ) : (
                          <div
                            style={{ minWidth: '30%' }}
                            className={styles.ParaDiv}
                          >
                            <div className={styles.toptext}>
                              <label className={styles.ParaName}>
                                تعداد بازدید
                              </label>
                              <span className={styles.paraDec}>
                                بعد از چه تعداد بازدید CTR محاسبه شود؟
                              </span>
                            </div>
                            <input
                              value={item?.pivot?.view_change}
                              type="text"
                              readOnly
                            />
                          </div>
                        )}
                        <div
                          style={{
                            height: '1px',
                            backgroundColor: '#ccc',
                            width: '100%',
                            margin: '20px 0',
                          }}
                        />
                      </div>
                    ))}
                  {landingsEditable?.landings?.map((item, index) => (
                    <div
                      key={index}
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        flexWrap: 'wrap',
                      }}
                    >
                      <div
                        style={{ minWidth: '30%' }}
                        className={styles.ParaDiv}
                      >
                        <div className={styles.toptext}>
                          <label
                            className={styles.ParaName}
                            htmlFor={`id-${index}`}
                          >
                            {`زیرمجموعه ${
                              unEditableLand?.length > 0
                                ? unEditableLand.length + index + 1
                                : index + 1
                            }`}
                          </label>
                          <span className={styles.paraDec}>
                            لطفا لندینگ فرزند را وارد کنید
                          </span>
                        </div>
                        <CustomSelect
                          options={allLandings}
                          placeholder="لندینگ را انتخاب کنید"
                          onInputChange={handleInputChange}
                          onChange={(selectedOption) => {
                            handleChange(
                              index,
                              'id',
                              selectedOption?.value
                            );
                          }}
                          isClearable
                          isSearchable
                        />
                      </div>

                      <div
                        style={{ minWidth: '30%' }}
                        className={styles.ParaDiv}
                      >
                        <div className={styles.toptext}>
                          <label
                            className={styles.ParaName}
                            htmlFor={`priority-${index}`}
                          >
                            الویت
                          </label>
                          <span className={styles.paraDec}>
                            {`
                            الویت از ${landPriority + 1} شروع میشود
                            `}
                          </span>
                        </div>
                        <input
                          onWheel={(e) => e.target.blur()}
                          value={item.priority}
                          type="number"
                          min={2}
                          onChange={(e) =>
                            handlePriorityLanding(
                              e.target.value,
                              index
                            )
                          }
                        />
                      </div>

                      {landings?.change_type === 'time_change' ? (
                        <div
                          style={{ minWidth: '30%' }}
                          className={styles.ParaDiv}
                        >
                          <div className={styles.toptext}>
                            <label className={styles.ParaName}>
                              مدت زمان
                            </label>
                            <span className={styles.paraDec}>
                              بعد از چه مدت زمانی CTR محاسبه شود؟
                            </span>
                          </div>
                          <input
                            value={item.time_change}
                            type="text"
                            onChange={(e) =>
                              handleChangeTimeLanding(
                                e.target.value,
                                index
                              )
                            }
                          />
                        </div>
                      ) : (
                        <div
                          style={{ minWidth: '30%' }}
                          className={styles.ParaDiv}
                        >
                          <div className={styles.toptext}>
                            <label className={styles.ParaName}>
                              تعداد بازدید
                            </label>
                            <span className={styles.paraDec}>
                              بعد از چه تعداد بازدید CTR محاسبه شود؟
                            </span>
                          </div>
                          <input
                            value={item.view_change}
                            type="text"
                            onChange={(e) =>
                              handleChangeViewLanding(
                                e.target.value,
                                index
                              )
                            }
                          />
                        </div>
                      )}
                      <div
                        style={{
                          height: '1px',
                          backgroundColor: '#ccc',
                          width: '100%',
                          margin: '20px 0',
                        }}
                      />
                    </div>
                  ))}
                </div>
                <button
                  style={{ margin: 20, padding: 5, width: 170 }}
                  className="btn btn-warning ms-2"
                  onClick={handleAddGroup}
                >
                  <i className="bi bi-plus"></i>
                  <span style={{ padding: 10 }}>
                    اضافه کردن زیرمجموعه
                  </span>
                </button>
              </div>
            </div>
          )}
        </div>

        <div className={`${copyOfInstallLanding.btns} mt-5 mb-4 `}>
          <button
            className="btn btn-primary ms-2"
            disabled={checkBtnEdite}
            onClick={checkChanges}
          >
            ویرایش لندینگ
            {checkBtnEdite && (
              <span
                className="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
              ></span>
            )}
          </button>

          <button
            data-bs-toggle="modal"
            style={{ visibility: 'hidden' }}
            id="btnModalAnswer"
            data-bs-target="#askUserTodo"
            onClick={showAwnserForLanding}
          ></button>

          <Link
            to={`${mainUrl}${editeLanding.slug}`}
            target="_blank"
            className="btn btn-warning"
          >
            مشاهده لندینگ
          </Link>
          <button
            className="btn btn-secondary me-2"
            onClick={() => navigate('/dashboard/showLandings')}
          >
            بازگشت
          </button>
        </div>

        <ModalYesorNo
          idModal="askUserTodo"
          color="primary"
          byLoading={true}
          stateLoad={isLoadForModalCheck}
          doBtn="تایید"
          Click={editeLandingHandler}
        >
          <div className="d-flex align-items-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="ms-3"
              width="1.9rem"
              height="1.9rem"
              viewBox="0 0 64 64"
            >
              <path
                fill="#ffce31"
                d="M5.9 62c-3.3 0-4.8-2.4-3.3-5.3L29.3 4.2c1.5-2.9 3.9-2.9 5.4 0l26.7 52.5c1.5 2.9 0 5.3-3.3 5.3z"
              />
              <g fill="#231f20">
                <path d="m27.8 23.6l2.8 18.5c.3 1.8 2.6 1.8 2.9 0l2.7-18.5c.5-7.2-8.9-7.2-8.4 0" />
                <circle cx="32" cy="49.6" r="4.2" />
              </g>
            </svg>
            <span>
              با تایپ و توکن این لندینگ {dataForModalCheck?.count}{' '}
              لندینگ دیگر وجود دارد آیا مایل به تایید این ویرایش
              هستید؟
            </span>
          </div>
          <a
            href={`/dashboard/showLandings?type=${editeLanding.parameters.type}&token=${editeLanding.parameters.token}`}
            target="_blank"
          >
            <button className="btn btn-sm btn-dark">مشاهده</button>
          </a>
        </ModalYesorNo>
      </div>
    </>
  ) : (
    <Loading color="#7545fb" />
  );
};

export default EditeLanding;
